
import { isSet, optionsToKeyValuePairs } from "../../../../../../utils/commonUtils";
import { computationRules1 } from "./DrugScreenCollection";

export const ScreeningPulmonary = (props)=>{
    // console.log('props.lookupsOptions',props.lookupsOptions);
    const charts = [{
        type:'Grid',
        col:'col-md-3',
        data:[{
            type:"PatientDetails",
            employeeDetails:props.employeeDetails,
            visitDetails:props.visitDetails
        },{
            type:"CompanyDetails",
            companyDetails:props.companyDetails
        }],
    },{
        type:'Tab',
        col:'col-md-9',
        data:[
            {
                id:'pulmonary_details',
                label:'Pulmonary Details',
                data:[
        { 
            label:'Forced vital capacity (FVC)',
            fields:[{
                label:'Actual - 1',
                col:'col-4',
                type:'Decimal',
                name:'fvc_actual_1',
                id:'fvc_actual_1',
            },
            {
                label:'Actual - 2',
                col:'col-4',
                type:'Decimal',
                name:'fvc_actual_2',
                id:'fvc_actual_2',
            },
            {
                label:'Actual - 3',
                col:'col-4',
                type:'Decimal',
                name:'fvc_actual_3',
                id:'fvc_actual_3',
            },
            {
                label:'Predicted',
                col:'col-4',
                type:'Decimal',
                name:'fvc_predicted',
                id:'fvc_predicted',
            }, 
            {
                label:'(Best) Actual',
                col:'col-4',
                readOnly:true,
                type:'Decimal',
                name:'fvc_best_actual',
                id:'fvc_best_actual',
            }, 
            {
                label:'% Predicted',
                col:'col-4',
                type:'Decimal',
                readOnly:true,
                name:'fvc_percentage_predicted',
                id:'fvc_percentage_predicted',
            }, 
        ]
        },
        { 
            label:'Forced expiratory volume (FEV1)',
            fields:[{
                label:'Actual - 1',
                col:'col-4',
                type:'Decimal',
                name:'fev1_actual_1',
                id:'fev1_actual_1',
            },
            {
                label:'Actual - 2',
                col:'col-4',
                type:'Decimal',
                name:'fev1_actual_2',
                id:'fev1_actual_2',
            },
            {
                label:'Actual - 3',
                col:'col-4',
                type:'Decimal',
                name:'fev1_actual_3',
                id:'fev1_actual_3',
            },
            {
                label:'Predicted',
                col:'col-4',
                type:'Decimal',
                name:'fev1_predicted',
                id:'fev1_predicted',
            }, 
            {
                label:'(Best) Actual',
                col:'col-4',
                readOnly:true,
                type:'Decimal',
                name:'fev1_best_actual',
                id:'fev1_best_actual',
            },
            {
                label:'% Predicted',
                col:'col-4',
                readOnly:true,
                type:'Decimal',
                name:'fev1_percentage_predicted',
                id:'fev1_percentage_predicted',
            }
        ]
        },
        { 
            label:'FEV1 / FVC',
            fields:[{
                label:'Actual - 1',
                col:'col-4',
                type:'Decimal',
                name:'fev1_fvc_actual_1',
                id:'fev1_fvc_actual_1',
            },
            {
                label:'Actual - 2',
                col:'col-4',
                type:'Decimal',
                name:'fev1_fvc_actual_2',
                id:'fev1_fvc_actual_2',
            },
            {
                label:'Actual - 3',
                col:'col-4',
                type:'Decimal',
                name:'fev1_fvc_actual_3',
                id:'fev1_fvc_actual_3',
            },
            {
                label:'Predicted',
                col:'col-4',
                type:'Decimal',
                name:'fev1_fvc_predicted',
                id:'fev1_fvc_predicted',
            }, 
            {
                label:'(Best) Actual',
                col:'col-4',
                type:'Decimal',
                readOnly:true,
                name:'fev1_fvc_best_actual',
                id:'fev1_fvc_best_actual',
            },
            {
                label:'% Predicted',
                col:'col-4',
                type:'Decimal',
                readOnly:true,
                name:'fev1_fvc_percentage_predicted',
                id:'fev1_fvc_percentage_predicted',
            }, 
        ]
        }, 
        { 
            label:'FEV6',
            fields:[{
                label:'Actual - 1',
                col:'col-4',
                type:'Decimal',
                name:'fev6_actual_1',
                id:'fev6_actual_1',
            },
            {
                label:'Actual - 2',
                col:'col-4',
                type:'Decimal',
                name:'fev6_actual_2',
                id:'fev6_actual_2',
            },
            {
                label:'Actual - 3',
                col:'col-4',
                type:'Decimal',
                name:'fev6_actual_3',
                id:'fev6_actual_3',
            },
            {
                label:'Predicted',
                col:'col-4',
                type:'Decimal',
                readOnly:true,
                name:'fev6_predicted',
                id:'fev6_predicted',
            }, 
           {
                label:'(Best) Actual',
                col:'col-4',
                type:'Decimal',
                readOnly:true,
                name:'fev6_best_actual',
                id:'fev6_best_actual',
            }, 
            {
                label:'% Predicted',
                col:'col-4',
                type:'Decimal',
                name:'fev6_percentage_predicted',
                id:'fev6_percentage_predicted',
            }, 
            
        ]
        },
        { 
            label:'FEV1 / FEV6',
            fields:[{
                label:'Actual - 1',
                col:'col-4',
                type:'Decimal',
                name:'fev1_fev6_actual_1',
                id:'fev1_fev6_actual_1',
            },
            {
                label:'Actual - 2',
                col:'col-4',
                type:'Decimal',
                name:'fev1_fev6_actual_2',
                id:'fev1_fev6_actual_2',
            },
            {
                label:'Actual - 3',
                col:'col-4',
                type:'Decimal',
                name:'fev1_fev6_actual_3',
                id:'fev1_fev6_actual_3',
            },
            {
                label:'Predicted',
                col:'col-4',
                type:'Decimal',
                name:'fev1_fev6_predicted',
                id:'fev1_fev6_predicted',
            },
            {
                label:'(Best) Actual',
                col:'col-4',
                type:'Decimal',
                readOnly:true,
                name:'fev1_fev6_best_actual',
                id:'fev1_fev6_best_actual',
            },  
            {
                label:'% Predicted',
                col:'col-4',
                type:'Decimal',
                readOnly:true,
                name:'fev1_fev6_percentage_predicted',
                id:'fev1_fev6_percentage_predicted',
            }, 
        ]
        },
        { 
            label:'FEF25-75%',
            fields:[{
                label:'Actual - 1',
                col:'col-4',
                type:'Decimal',
                name:'fef25_75_actual_1',
                id:'fef25_75_actual_1',
            },
            {
                label:'Actual - 2',
                col:'col-4',
                type:'Decimal',
                name:'fef25_75_actual_2',
                id:'fef25_75_actual_2',
            },
            {
                label:'Actual - 3',
                col:'col-4',
                type:'Decimal',
                name:'fef25_75_actual_3',
                id:'fef25_75_actual_3',
            },
            {
                label:'Predicted',
                col:'col-4',
                type:'Decimal',
                name:'fef25_75_predicted',
                id:'fef25_75_predicted',
            }, 
            {
                label:'(Best) Actual',
                col:'col-4',
                type:'Decimal',
                readOnly:true,
                name:'fef25_75_best_actual',
                id:'fef25_75_best_actual',
            }, 
            {
                label:'% Predicted',
                col:'col-4',
                type:'Decimal',
                readOnly:true,
                name:'fef25_75_percentage_predicted',
                id:'fef25_75_percentage_predicted',
            }, 
        ]
        },
        { 
            label:'PEFR',
            fields:[{
                label:'Actual - 1',
                col:'col-4',
                type:'Decimal',
                name:'pefr_actual_1',
                id:'pefr_actual_1',
            },
            {
                label:'Actual - 2',
                col:'col-4',
                type:'Decimal',
                name:'pefr_actual_2',
                id:'pefr_actual_2',
            },
            {
                label:'Actual - 3',
                col:'col-4',
                type:'Decimal',
                name:'pefr_actual_3',
                id:'pefr_actual_3',
            },
            {
                label:'Predicted',
                col:'col-4',
                type:'Decimal',
                name:'pefr_predicted',
                id:'pefr_predicted',
            }, 
            {
                label:'(Best) Actual',
                col:'col-4',
                type:'Decimal',
                readOnly:true,
                name:'pefr_best_actual',
                id:'pefr_best_actual',
            }, 
            {
                label:'% Predicted',
                col:'col-4',
                type:'Decimal',
                readOnly:true,
                name:'pefr_percentage_predicted',
                id:'pefr_percentage_predicted',
            }, 
        ]
        },
        {
            label:'Status & Others',
            fields:[
                {
                    label:'Pulmonary Classifications',
                    col:'col-12',
                    type:'UnorderedList',
                    notes:["FVC (Restrictive) Classification:  No Restrictive Disease","FEV1 (Obstructive) Classification:  No Obstructive Disease","NIOSH Respirator Classification:   Approved for Unlimited Use"],
                },
                {
                    label:'Notes',
                    col:'col-12',
                    type:'TextArea',
                    name:'notes',
                },
            // {
            //     label:'Status',
            //     col:'col-6',
            //     type:'SelectList',
            //     options:isSet(props.lookupsOptions['chartResult'],[]),
            //     name:'status',
            // },
           
           
        ]
        },
        {
            label: 'Review / Completion',
            // labelStyle: 'fw-semibold',
            fields: [
                {
                    type: 'ProviderSignOff',
                    col: 'col-12',
                    fields: [
                        { label: 'Signature PIN', name: 'provider_pin', col: 'col-12' },
                        { label: 'Signature', type: 'NewSignature', name: 'provider_signature', col: 'col-12' },
                        { label: 'Date', type: 'Date', name: 'signed_date', col: 'col-12' },
                        // { label : "Suggested Result",disabled:true, placeholder:'Not Started',type: "TextInput", name: "suggested_status", col: "col-6"},
                        // Previous options:
                        // { label : "Final Results", type: "SelectList", name: "status", col: "col-12", options:isSet(props.lookupsOptions['chartResult'],[]),statusBasedColor: true },
                        // { label : "Activity Status", type: "SelectList", name: "activity_status", col: "col-12", options: optionsToKeyValuePairs(['Not Started','Ordered','Completed','Cancelled']),statusBasedColor: true },
                        // New standard options:
                        { 
                          label : "Final Results",
                          type: "SelectList",
                          name: "status",
                          col: "col-12",
                          options: optionsToKeyValuePairs(
                            [
                              "Not Started",
                              "Pending",
                              "Normal",
                              "Abnormal",
                              "Negative",
                              "Positive",
                              "Dispensed",
                              "Administered",
                              "Failed",
                              "Passed",
                              "Non-Negative",
                              "Cancelled",
                              "Inconclusive",
                            ],
                            false
                          ),
                          statusBasedColor: true,
                        },
                        { 
                          label : "Activity Status",
                          type: "SelectList",
                          name: "activity_status",
                          col: "col-12",
                          options: optionsToKeyValuePairs(
                            [
                              "Not Started",
                              "Pending",
                              "Pending Lab Confirmation",
                              "Pending MRO Confirmation",
                              "Ready for Review",
                              "Completed",
                              "Cancelled",
                            ],
                            false
                          ),
                          statusBasedColor: true,
                        },
                    ],
                },
            ],
        }
                ]
            },
            {
                id:'Images',
                label:'Images',
                data:[]
            }
        ]
    }];
    const defaultValue = {
        status:'Not Started',
        suggested_status:'Not Started',
        activity_status:'Not Started',
        // reason:'Pre-employment'
    };
    const headers = [{
        type: 'Tab',
        data: [
            {
                label: 'Pulmonary Details',
                id: 'pulmonary_details'
            },
            {
                label: 'Images',
                id: 'Images'
            }
        ]
    }];
    return {
        charts,
        defaultValue,
        headers,
        computationFunction: (formData, key) => ({
            ...computationRules(formData),
            ...computationRules1(formData, key),
        }),
    };
}


const computationRules = (formData)=>{
    let returnData = {}; 
    const prefixes = ["fvc","fev1","fev1_fvc","fev6","fev1_fev6","fef25_75","pefr"]; // Define the prefixes
    prefixes.forEach(prefix => {
        const actual1 = isSet(formData[prefix + '_actual_1'], 0);
        const actual2 = isSet(formData[prefix + '_actual_2'], 0);
        const actual3 = isSet(formData[prefix + '_actual_3'], 0);
        let bestActual = isSet(formData[prefix + '_best_actual'], 0);
        const predicted = isSet(formData[prefix + '_predicted'], 0);

        const best_actual = Math.max(actual1, actual2, actual3);
        if(best_actual!==0){
            bestActual = best_actual;
            returnData = {
                ...returnData,
                [prefix + '_best_actual']: best_actual
            };
        }
        

        if (bestActual !== 0 && predicted !== 0) {
            const percentage_predicted = ((Number(bestActual) / Number(predicted)) * 100).toFixed(2);
            returnData = {
                ...returnData,
                [prefix + '_percentage_predicted']: percentage_predicted
            };
        }
    });
    return {...returnData};

}